import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EmbeddedViewRef,
  Injector,
  Input,
  OnChanges,
} from "@angular/core";
import { MarkdownService } from "../../markdown/markdown.service";
import { CopyButtonWithTooltipComponent } from "./copy-button-with-tooltip.component";

@Component({
  selector: "ab-instructions",
  templateUrl: "./instructions.component.html",
})
export class InstructionsComponent implements OnChanges {
  @Input() public rawMarkdown: string;
  @Input() public language: string;
  public instructions: string;
  public nativeEl: any;

  constructor(
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private elem: ElementRef,
    private injector: Injector,
    private markdownService: MarkdownService,
  ) {
    this.nativeEl = this.elem.nativeElement;
  }

  public ngOnChanges() {
    this.instructions = this.markdownService.md.render(this.rawMarkdown);

    setTimeout(this.addLinkTarget.bind(this));
    setTimeout(this.addQuickCopy.bind(this));
  }

  private addLinkTarget() {
    const links = this.nativeEl.querySelectorAll("a.external-link");
    for (const link of links) {
      link.setAttribute("target", "_blank");
    }
  }

  private addQuickCopy() {
    const codeBlocks = this.nativeEl.querySelectorAll("pre");
    for (const codeBlock of codeBlocks) {
      const componentRef = this.componentFactoryResolver
        .resolveComponentFactory(CopyButtonWithTooltipComponent)
        .create(this.injector);

      componentRef.instance.language = this.language;
      componentRef.instance.textToCopy = codeBlock.textContent;

      this.appRef.attachView(componentRef.hostView);

      const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0];

      codeBlock.before(domElem);
    }
  }
}
